var icon = require('vue-svgicon')
icon.register({
  'ks-icon-attachment': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M78.66 42v42.16a14.66 14.66 0 0 1-29.32 0V38.34a9.16 9.16 0 1 1 18.33 0v38.49a3.67 3.67 0 0 1-7.33 0V42h-5.5v34.83a9.16 9.16 0 0 0 18.33 0V38.34a14.66 14.66 0 1 0-29.32 0v45.82a20.16 20.16 0 0 0 40.32 0V42z"/>'
  }
})
